import { render } from "./unggahAsuransi.vue?vue&type=template&id=3de8b8dd&scoped=true"
import script from "./unggahAsuransi.vue?vue&type=script&lang=js"
export * from "./unggahAsuransi.vue?vue&type=script&lang=js"

import "./unggahAsuransi.vue?vue&type=style&index=0&id=3de8b8dd&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de8b8dd"]])

export default __exports__